<template>
  <v-expansion-panels>
    <v-expansion-panel
      v-for="i in getNavigationConfiguration.size"
      :key="`history-list-loader-item-${i + 1}`"
      class="history-list-loader-item-expansion-wrapper"
    >
      <Loaders type="button" />
      <div class="history-list-loader-item-wrapper ml-4">
        <Loaders type="label" />
        <Loaders type="label" />
        <Loaders type="expansionButton" />
      </div>
    </v-expansion-panel>
  </v-expansion-panels>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Loaders from '@/components/common/Loaders/Loaders.vue';
import { INavigation, store } from '@/store/modules/history/types';
import './styles/history-loader.scss';

@Component({
  components: {
    Loaders
  }
})
export default class HistoryLoader extends Vue {
  @store.Getter
  private getNavigationConfiguration!: INavigation;
}
</script>
